import { Formik } from "formik";
import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { Fragment, useState } from "react";

import FormOne from "./FormOne";
import FormTwo from "./FormTwo";
import FormThree from "./FormThree";
import { useAxios } from "../../../hooks";
import {
  ButtonFooter,
  ComponentHeader,
  PageHeader,
  Paper,
} from "../../../components";
import { ActiveTextEighteen, colors } from "../../css components/Style";
import ViewAgreement from "../../company components/agreement components/ViewAgreement";
import {
  objectFromFormData,
  objectFromResponseData,
  validationSchema,
} from "../../company components/company details components/companyDetailsObject";
import FormThreeUpload from "../../company components/company details components/FormThree";
import EditButtons from "../../../components/EditButtons";
import FormFour from "../../superadmin unverified agencies/unverified company details/FormFour";
import { alert } from "../../../redux/slices/alertSlice";

export default function FormDisplay({
  editState,
  setFormData,
  formData,
  setEditState,
  noDetails,
  brandID,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();

  const [viewAgreement, setViewAgreement] = useState({
    data: {},
    state: false,
  });
  return (
    <Fragment>
      <Grid size={12}>
        <PageHeader
          pageName={"Company Details"}
          pageHeader={formData.companyName}
          buttons={[
            parseInt(formData.is_brand_verified) === 0 && (
              <EditButtons editState={editState} setEditState={setEditState} />
            ),
          ]}
        />
      </Grid>

      {noDetails && (
        <Paper>
          <Grid size={12} alignSelf={"center"}>
            <ActiveTextEighteen color={colors.error}>
              Brand hasn't registered it's company yet.
            </ActiveTextEighteen>
          </Grid>
        </Paper>
      )}

      <Formik
        enableReinitialize
        initialValues={formData}
        validateOnMount
        validationSchema={validationSchema}
        onSubmit={(formData, { setSubmitting }) => {
          axios({
            url: "/user/companyProfile",
            method: "POST",
            disableRedirect: true,
            data: objectFromFormData(formData, brandID),
          })
            .then((response) => {
              if (response.status) {
                setFormData(objectFromResponseData(response.data));
                dispatch(
                  alert({
                    type: "success",
                    message: response.message.displayMessage,
                  })
                );
                setEditState(false);
              } else {
                dispatch(
                  alert({
                    type: "error",
                    message: response.message,
                  })
                );
              }
              setSubmitting(false);
            })
            .catch((err) => {
              console.error(err);
            });
        }}
      >
        {(formikProps) => (
          <Fragment>
            <Paper gridSpacing={4}>
              <Grid size={12}>
                <ComponentHeader title={"Company Details"} />
              </Grid>
              <FormOne
                brandID={brandID}
                editState={editState}
                formikProps={formikProps}
              />

              <FormTwo
                formData={formData}
                formikProps={formikProps}
                editState={editState}
              />

              {!editState ? (
                <FormThree editState={editState} formikProps={formikProps} />
              ) : (
                <FormThreeUpload
                  editState={editState}
                  formikProps={formikProps}
                />
              )}
            </Paper>

            {editState && (
              <Grid size={12}>
                <ButtonFooter
                  disabled={!formikProps.values.gstVerified}
                  editState={editState}
                  setEditState={setEditState}
                  ID={formikProps.values.ID}
                  formikProps={formikProps}
                />
              </Grid>
            )}

            {formikProps?.values?.ID && (
              <Paper>
                <FormFour
                  brandID={brandID}
                  editState={editState}
                  formikProps={formikProps}
                />
              </Paper>
            )}
          </Fragment>
        )}
      </Formik>

      <ViewAgreement
        viewAgreement={viewAgreement}
        setViewAgreement={setViewAgreement}
      />
    </Fragment>
  );
}
